import { sgqDocumentIcon } from '@/assets/images/svg/sgqDocument'
import {
  mdiAccountGroup,
  mdiAccountVoice,
  mdiFileAccountOutline,
  mdiMessageProcessingOutline,
} from '@mdi/js'
import localStorageSlim from 'localstorage-slim'

const userProfile = localStorageSlim.get('userProfile', { decrypt: true })

const Sgq = [
  {
    subheader: 'SGQ',
  },
  {
    title: 'RIC',
    icon: mdiAccountVoice,
    children: [
      {
        title: 'Registrar',
        to: 'sgq-home',
        hidden: false,
        ActiveTabColor: '#168ED7',
        ActiveTabColor2: '#0085FF',
        ActiveTabColor3: '#16B1FF',
      },
    ],
  },
  {
    title: 'RI`s',
    icon: mdiMessageProcessingOutline,
    children: [
      {
        title: 'Registrar',
        to: 'sgq-internal-complaint',
        hidden: false,
        ActiveTabColor: '#168ED7',
        ActiveTabColor2: '#0085FF',
        ActiveTabColor3: '#16B1FF',
      },
    ],
  },
]

if (userProfile) {
  const isLevelTwo = userProfile?.hierarchical_profile === 'nivel_2'
  const isLevelThree = userProfile?.hierarchical_profile === 'nivel_3'
  const isLevelFour = userProfile?.hierarchical_profile === 'nivel_4'
  const profileName = userProfile?.profile?.profile
  const isPersonalDepartament = userProfile?.profile?.profile === 'Departamento Pessoal'
  const regexRelationshipCenter = /central\s+de\s+relacionamento/i
  const regexHumanResources = /recursos\s+humanos/i
  const regexAdministrator = /administrador/i
  const isHumanResources = regexHumanResources.test(profileName)
  const isRelationshipCenter = regexRelationshipCenter.test(profileName)
  const isAdministrator = regexAdministrator.test(profileName)
  const rolesExceptions = ['ANALISTA DE TREINAMENTO', 'ASSISTENTE DE TREINAMENTO']

  if (isLevelTwo || isLevelThree) {
    Sgq[1]?.children.push(
      {
        title: 'Usuários por RIC',
        to: 'sgq-user-by-ric',
        hidden: false,
        ActiveTabColor: '#168ED7',
        ActiveTabColor2: '#0085FF',
        ActiveTabColor3: '#16B1FF',
      },
      {
        title: 'Tipos de reclamação',
        to: 'sgq-control-panel',
        hidden: false,
        ActiveTabColor: '#168ED7',
        ActiveTabColor2: '#0085FF',
        ActiveTabColor3: '#16B1FF',
      },
    )

    Sgq.splice(2, 0, {
      title: 'SAC`s',
      icon: mdiFileAccountOutline,
      children: [
        {
          title: 'Registrar',
          to: 'sgq-sac',
          hidden: false,
          ActiveTabColor: '#168ED7',
          ActiveTabColor2: '#0085FF',
          ActiveTabColor3: '#16B1FF',
        },
      ],
    })

    if (!rolesExceptions.includes(userProfile.occupation_sector?.occupation?.name)) {
      Sgq.push({
        title: 'GESTÃO DE PESSOAS',
        icon: mdiAccountGroup,
        children: [
          {
            title: 'Requisitar',
            to: 'person-request',
            hidden: false,
            ActiveTabColor: '#168ED7',
            ActiveTabColor2: '#0085FF',
            ActiveTabColor3: '#16B1FF',
          },
          {
            title: 'Desligar',
            to: 'employee-offboarding',
            hidden: false,
            ActiveTabColor: '#168ED7',
            ActiveTabColor2: '#0085FF',
            ActiveTabColor3: '#16B1FF',
          },

          {
            title: 'Movimentar',
            to: 'movimentations',
            hidden: false,
            ActiveTabColor: '#168ED7',
            ActiveTabColor2: '#0085FF',
            ActiveTabColor3: '#16B1FF',
          },
        ],
      })
    }
  }

  // NOTE - the module was removed from the project
  // if ((isRelationshipCenter && isLevelTwo) || isLevelThree) {
  //   Sgq.push({
  //     title: 'DOCUMENTOS',
  //     icon: mdiAccessPointCheck,
  //     children: [
  //       {
  //         title: 'Processos',
  //         to: 'sgq-processes',
  //         hidden: false,
  //       },
  //       {
  //         title: 'Tipos',
  //         to: 'sgq-types',
  //         hidden: false,
  //       },
  //       {
  //         title: 'Documentos',
  //         to: 'sgq-documents',
  //         hidden: false,
  //       },
  //       {
  //         title: 'Arquivos',
  //         to: 'sgq-files',
  //         hidden: false,
  //       },
  //       {
  //         title: 'Função/Documentos',
  //         to: 'sgq-docs-on-occupation',
  //         hidden: false,
  //       },
  //     ],
  //   })
  // }

  if (
    ((isHumanResources || isRelationshipCenter || isAdministrator || isPersonalDepartament) &&
      isLevelTwo) ||
    isLevelThree
  ) {
    Sgq.push({
      title: 'DOCUMENTOS',
      icon: sgqDocumentIcon,
      children: [
        {
          title: 'Painel',
          to: 'sgq-panel-companies',
          hidden: false,
          ActiveTabColor: '#168ED7',
          ActiveTabColor2: '#0085FF',
          ActiveTabColor3: '#16B1FF',
        },
        {
          title: 'Ferramentas',
          to: 'sgq-tools',
          hidden: false,
          ActiveTabColor: '#168ED7',
          ActiveTabColor2: '#0085FF',
          ActiveTabColor3: '#16B1FF',
        },
        {
          title: 'Inativados',
          to: 'sgq-inactive-documents',
          hidden: false,
        },
      ],
    })
  }

  if (isLevelThree || isLevelFour) {
    Sgq[3]?.children.unshift({
      title: 'Dashboard',
      to: 'sgq-internal-complaint-dashboard',
      hidden: false,
      ActiveTabColor: '#168ED7',
      ActiveTabColor2: '#0085FF',
      ActiveTabColor3: '#16B1FF',
    })

    // Sgq.push({
    //   title: 'RELATÓRIOS',
    //   icon: mdiFileDocument,
    //   children: [
    //     {
    //       title: 'Canal do diretor',
    //       to: 'sgq-reports-director-channel',
    //       hidden: false,
    //     },
    //   ],
    // })
  }
}

export default Sgq
